import script from "./RefreshIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./RefreshIcon.vue?vue&type=script&setup=true&lang=js"

import "./RefreshIcon.vue?vue&type=style&index=0&id=fa0a790c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa0a790c"]])

export default __exports__